export const ROUTE_PATH = {
	HOMEPAGE: {
		NAME: 'Homepage',
		LINK: '/homepage',
	},
	INSURANCE: {
		NAME: 'Insurance',
		LINK: '/insurance',
	},
	VEHICLE_SELECTION: {
		NAME: 'Vehicle Selection',
		LINK: '/vehicle-selection',
	},
	QUOTATION: {
		NAME: 'Quotation',
		LINK: '/quotation',
	},
	WORKWAITING: {
		NAME: 'Work Waiting',
		LINK: '/work-waiting',
	},
	COMPULSORY_MOTOR: {
		NAME: 'Compulsory Motor',
		LINK: '/compulsory-motor',
	},
	CAR_INSURANCE: {
		NAME: 'Car Insurance',
		LINK: '/car-insurance',
	},
	CAR_INSURANCE_WHIT_COMPULSORY: {
		NAME: 'Car Insurance with Compulsory',
		LINK: '/car-insurance-whit-compulsory',
	},
	TAX_CALCULATOR: {
		NAME: 'Tax Calculator',
		LINK: '/tax-calculator',
	},
	SELECT_PLAN: {
		NAME: 'Select Plan',
		LINK: '/select-plan',
	},
	BILL: {
		NAME: 'Bill',
		LINK: '/bill',
	},
	BILLLIST: {
		NAME: 'BillList',
		LINK: '/billlist',
	},
	PROFILE: {
		NAME: 'Profile',
		LINK: '/profile',
	},
	PREVIEW: {
		NAME: 'Preview',
		LINK: '/preview',
	},
	PRINT: {
		NAME: 'Print',
		LINK: '/print',
	},
	SUMMARY: {
		NAME: 'Summary',
		LINK: '/summary',
	},
	CREDIT: {
		NAME: 'Credit',
		LINK: '/credit',
	},
	REPORT: {
		NAME: 'Report',
		LINK: '/report',
	},
	UPLOADSLIPBILL: {
		NAME: 'Upload Slip Bill',
		LINK: '/upload-slip-bill',
	},
	COMMISSION_TABLE: {
		NAME: 'Commission',
		LINK: '/commission-table',
	},
	INSURANCE_QUANTITY: {
		NAME: 'Insurance Quantity',
		LINK: '/insurance-quantity',
	},
	SYSTEM_PAY_INSURANCE: {
		NAME: 'SYSTEM PAY INSURANCE',
		LINK: '/system-pay-insurance',
	},
	DEBIT: {
		NAME: 'Debit',
		LINK: '/debit',
	},
	PAYMENTTRO: {
		NAME: 'PAYMENTTRO',
		LINK: '/payment-tro',
	},
	INVOICE_ADMIN: {
		NAME: 'Invoice Admin',
		LINK: '/admin/invoice',
	},
	CANCEL_INSURANCE_ADMIN: {
		NAME: 'Cancel Insurance Admin',
		LINK: '/admin/cancel-insurance',
	},
	ALL_INSURANCE_ADMIN: {
		NAME: 'All Insurance Admin',
		LINK: '/admin/all-insurance',
	},
	NON_ACTIVE_ADMIN: {
		NAME: 'NON ACTIVE ADMIN',
		LINK: '/admin/non-active',
	},
	COMPANYONVIF_ADMIN: {
		NAME: 'ON COMPANY ADMIN',
		LINK: '/admin/on-company',
	},
	LOCKUSER_ADMIN: {
		NAME: 'LOCKUSER_ADMIN',
		LINK: '/admin/lockuser',
	},
	INSURANCE_OIDS_ADMIN: {
		NAME: 'INSURANCE_OIDS_ADMIN',
		LINK: '/admin/insurance-olds',
	},
	CREATE_USER_ADMIN: {
		NAME: 'CREATE_USER_ADMIN',
		LINK: '/admin/createuseradmin',
	},
	GEN_QRCODE_ADMIN: {
		NAME: 'Gen_Qrcode_ADMIN',
		LINK: '/admin/gen-qrcode-admin',
	},
	CREATE_USER: {
		NAME: 'CREATE_USER',
		LINK: '/admin/createuser',
	},
	CREATE_USER_BY_CUSCODE: {
		NAME: 'CREATE_USER_BY_CUSCODE',
		LINK: '/admin/userbycoscode',
	},
	PAY_INSTALLMENT: {
		NAME: 'Pay Installment Admin',
		LINK: '/admin/pay-installment',
	},
	CHECK_CREDIT_RETURN: {
		NAME: 'Check Credit Return',
		LINK: '/admin/check-credit-return',
	},
	CHECK_LOG_API: {
		NAME: 'Check Log Api',
		LINK: '/admin/check-log-api',
	},
	DOWNLINE_SALE: {
		NAME: 'Downline Sale',
		LINK: '/admin/downline-sale',
	},
	ENDORSE_INSURANCE_ADMIN: {
		NAME: 'Endorse Insurance Admin',
		LINK: '/admin/endorse-insurance',
	},
	CHECK_ALL_COMMISSION: {
		NAME: 'Check All Commission',
		LINK: '/admin/check-all-commission',
	},
	PAYMENT_ACCOUNTREPORT: {
		NAME: 'Payment AccountReport',
		LINK: '/accountreport/payment',
	},
	OUTSTANDING_BALANCE: {
		NAME: 'OUTSTANDING BALANCE',
		LINK: '/accountreport/outstanding-balance',
	},
	RECEIVABLES: {
		NAME: 'RECEIVABLES',
		LINK: '/accountreport/receivables',
	},
	BILLING: {
		NAME: 'BILLING',
		LINK: '/accountreport/billing',
	},
	BILLFOLLOWOSDBALANCE: {
		NAME: 'BILLFOLLOWOSDBALANCE',
		LINK: '/accountreport/BillFollowOsdBalance',
	},
	AGING: {
		NAME: 'AGING',
		LINK: '/accountreport/aging',
	},
	SELLLIST: {
		NAME: 'SELLLIST',
		LINK: '/accountreport/selllist',
	},
	REPORTCANCEL: {
		NAME: 'REPORTCANCEL',
		LINK: '/accountreport/reportcancel',
	},
	REPORTDEBIT: {
		NAME: 'REPORTDEBIT',
		LINK: '/accountreport/reportdebit',
	},
	REPORTCHECKSLIPBILL: {
		NAME: 'REPORTCHECKSLIPBILL',
		LINK: '/accountreport/reportcheckslipbill',
	},
	OVERDUE: {
		NAME: 'Overdue AccountReport',
		LINK: '/accountreport/overdue',
	},
	REPORTLOGERROR: {
		NAME: 'REPORTLOGERROR',
		LINK: '/accountreport/reportlogerror',
	},
	REPORTMATCHLISTDEBIT: {
		NAME: 'REPORTMATCHLISTDEBIT',
		LINK: '/accountreport/report-match-list-debit',
	},
	TAXRENEW: {
		NAME: 'TAXRENEW',
		LINK: '/TaxRenew',
	},
	EDIT: {
		NAME: 'EDIT',
		LINK: '/TaxRenew/Edit',
	},
	TAXBILL: {
		NAME: 'TAXBILL',
		LINK: '/TaxBill',
	},
	STATUS: {
		NAME: 'STATUS',
		LINK: '/Status',
	},
	DETAIL: {
		NAME: 'DETAIL',
		LINK: '/Status/Detail',
	},
	WAITRENEW: {
		NAME: 'WAITRENEW',
		LINK: '/WaitRenew',
	},
	STATUSRENEW: {
		NAME: 'STATUSRENEW',
		LINK: '/StatusRenew',
	},
	WINWHEEL: {
		NAME: 'WINWHEEL',
		LINK: '/winwheel',
	},
	REPORTWITHDRAW: {
		NAME: 'REPORTWITHDRAW',
		LINK: '/accountreport/reportwithdraw',
	},
	DOCOTHER: {
		NAME: 'DocOther',
		LINK: '/docOther',
	},
	BILLACCOUNT: {
		NAME: 'BillAccount',
		LINK: '/billaccount',
	},
	UNLOCK_WAIT_COMPANY: {
		NAME: 'UnlockWaitCompany',
		LINK: '/admin/unlock-wait-company',
	},
	CHECK_DUPP_POLICY: {
		NAME: 'CHECK_DUPP_POLICY',
		LINK: '/admin/check_dupp_policy',
	},
	DEDUCT_CREDIT: {
		NAME: 'DEDUCT_CREDIT',
		LINK: '/admin/deduct_credit',
	},
	EDIT_DETAIL_USER: {
		NAME: 'EDIT_DETAIL_USER',
		LINK: '/admin/edit_detail_user',
	},
	REPRINT_COMPANY: {
		NAME: 'REPRINT_COMPANY',
		LINK: '/admin/reprint-company',
	},
}
